export default __webpack_public_path__ + "static/media/bol_scan_3.5363a298.svg";